export { parseSingleCurlyBraceClozePromptMarkup } from "./util/parseClozeMarkup.js";
export var TaskSpecType;
(function (TaskSpecType) {
    TaskSpecType["Memory"] = "memory";
    // In the future: Generic, Custom, etc
})(TaskSpecType || (TaskSpecType = {}));
export const mainTaskComponentID = "main";
export var TaskContentType;
(function (TaskContentType) {
    TaskContentType["QA"] = "qa";
    TaskContentType["Cloze"] = "cloze";
    TaskContentType["Plain"] = "plain";
})(TaskContentType || (TaskContentType = {}));
export var TaskProvenanceSelectorType;
(function (TaskProvenanceSelectorType) {
    TaskProvenanceSelectorType["Range"] = "RangeSelector";
    TaskProvenanceSelectorType["TextPosition"] = "TextPositionSelector";
    TaskProvenanceSelectorType["TextQuote"] = "TextQuoteSelector";
    TaskProvenanceSelectorType["XPath"] = "XPathSelector";
})(TaskProvenanceSelectorType || (TaskProvenanceSelectorType = {}));
//# sourceMappingURL=task.js.map